const BUGLOG_SCRIPT_ID = 'buglog-script';
const BUGLOG_WARNING_ID = '_buglog-help-text';
const BUGLOG_CONTAINER_SELECTOR = '#_buglog-container';
const BUGLOG_USERNAME_SELECTOR = '#_buglog-username';
const BUGLOG_FORM_SELECTOR = '#_buglog-form';
const BUGLOG_PREVIEW_SELECTOR = '#_buglog-preview-container';
const BUGLOG_HELP_TEXT = 'Hinweis: Bitte geben Sie keine persönlichen / vertraulichen Informationen ein';
const BUGLOG_OBSERVER_TIMEOUT_MS = 15000;

function getBuglogProjectId() {
  return (process.env.REACT_APP_BUGLOG_PROJECT_ID || '').trim();
}

function initBuglog() {
  const projectId = getBuglogProjectId();
  if (!projectId) {
    return false;
  }

  if (window.__buglogInitialized) {
    return true;
  }

  const existingScript = document.getElementById(BUGLOG_SCRIPT_ID);
  if (existingScript) {
    window.__buglogInitialized = true;
    return true;
  }

  const script = document.createElement('script');
  script.id = BUGLOG_SCRIPT_ID;
  script.src = `https://api.buglog.com/website/${projectId}/code`;
  script.async = true;

  document.head.appendChild(script);
  window.__buglogInitialized = true;

  return true;
}

function applyBuglogDomCustomizations() {
  const username = document.querySelector(BUGLOG_USERNAME_SELECTOR);
  if (username) {
    username.remove();
  }

  const form = document.querySelector(BUGLOG_FORM_SELECTOR);
  const previewContainer = document.querySelector(BUGLOG_PREVIEW_SELECTOR);

  if (!form || !previewContainer) {
    return false;
  }

  const existingHelpText = document.getElementById(BUGLOG_WARNING_ID);
  if (existingHelpText) {
    return true;
  }

  const helpText = document.createElement('small');
  helpText.id = BUGLOG_WARNING_ID;
  helpText.innerText = BUGLOG_HELP_TEXT;
  form.insertBefore(helpText, previewContainer);

  return true;
}

function applyBuglogCustomizations() {
  if (applyBuglogDomCustomizations()) {
    return;
  }

  const observer = new MutationObserver(() => {
    if (!document.querySelector(BUGLOG_CONTAINER_SELECTOR)) {
      return;
    }

    if (applyBuglogDomCustomizations()) {
      observer.disconnect();
      clearTimeout(timeoutId);
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  const timeoutId = setTimeout(() => {
    observer.disconnect();
  }, BUGLOG_OBSERVER_TIMEOUT_MS);
}

function initBuglogForAuthenticatedUser() {
  if (!initBuglog()) {
    return;
  }

  applyBuglogCustomizations();
}

export {
  initBuglog,
  applyBuglogCustomizations,
  initBuglogForAuthenticatedUser,
};
